module.exports = __webpack_public_path__ + "af97ede6ad236227bdddd740fa49a77d.png";


//////////////////
// WEBPACK FOOTER
// ./src/act/march_promotion/img/success.png
// module id = 278
// module chunks = 0